import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Funciona si soy irregular?',
    answer: 'Sí, el libro te enseña a identificar las señales biológicas de tu cuerpo para saber en qué fase estás sin importar el calendario.'
  }, {
    question: '¿Es apto para veganas/vegetarianas?',
    answer: 'El recetario incluye opciones y sustituciones para todo tipo de alimentación.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Inmediatamente después del pago, recibirás un correo con los enlaces de acceso de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-32 bg-white" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-charcoal mb-4" data-id="element-23">
            Preguntas Frecuentes
          </h2>
          <p className="text-deep-charcoal/70" data-id="element-24">
            Resolvemos tus dudas antes de empezar
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-cream-white rounded-2xl overflow-hidden bg-cream-white/30" data-id="element-26">
              <button onClick={() => toggleFAQ(index)} className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-27">
                <span className="font-bold text-deep-charcoal text-base md:text-lg" data-id="element-28">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-dusty-rose transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>

              <AnimatePresence data-id="element-30">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-31">
                    <div className="px-6 pb-5 text-deep-charcoal/80 leading-relaxed" data-id="element-32">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}